var _metadata, _clipPath, _clipPath2, _clipPath3, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrittanyFerries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg3853",
    viewBox: "0 0 1000 269",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3859"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs3857"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3869"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 36,388.96 540,0 0,309 -540,0 0,-309 z",
    id: "path3871"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3937"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 612,0 612,792 0,792 0,0 z",
    id: "path3939"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14260"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,1190.551 841.89,0 L 841.89,0 0,0 0,1190.551 z",
    id: "path14262"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.488363,10.478982,10.478982,-12.488363,501.83249,399.38715)",
    spreadMethod: "pad",
    id: "linearGradient14238"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#2c1e4f"
    },
    offset: 0,
    id: "stop14240"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#43316b"
    },
    offset: 0.148081,
    id: "stop14242"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#5e4796"
    },
    offset: 0.254245,
    id: "stop14244"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#74509d"
    },
    offset: 0.539152,
    id: "stop14246"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#9963a9"
    },
    offset: 0.72749,
    id: "stop14248"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fbcce8"
    },
    offset: 0.994988,
    id: "stop14250"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#fbcce8"
    },
    offset: 1,
    id: "stop14252"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 232.75,
    y1: 21.530001,
    x2: 265.53,
    y2: 69.779999,
    id: "gradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#bccf21",
    stopOpacity: 1,
    id: "stop9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#76b82a",
    stopOpacity: 1,
    id: "stop11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#02622c",
    stopOpacity: 1,
    id: "stop13"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 232.75,
    y1: 21.530001,
    x2: 265.53,
    y2: 69.779999,
    id: "linearGradient3164"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#bccf21",
    stopOpacity: 1,
    id: "stop3166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#76b82a",
    stopOpacity: 1,
    id: "stop3168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#02622c",
    stopOpacity: 1,
    id: "stop3170"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 234.96001,
    y1: 49.290001,
    x2: 269.81,
    y2: -9.1800003,
    id: "gradient2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#27348b",
    stopOpacity: 1,
    id: "stop16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0053a1",
    stopOpacity: 1,
    id: "stop18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0bbbef",
    stopOpacity: 1,
    id: "stop20"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 234.96001,
    y1: 49.290001,
    x2: 269.81,
    y2: -9.1800003,
    id: "linearGradient3176"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#27348b",
    stopOpacity: 1,
    id: "stop3178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0053a1",
    stopOpacity: 1,
    id: "stop3180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0bbbef",
    stopOpacity: 1,
    id: "stop3182"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 268.78,
    y1: 67.889999,
    x2: 303.04999,
    y2: 10.38,
    id: "gradient3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e30613",
    stopOpacity: 1,
    id: "stop23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f39325",
    stopOpacity: 1,
    id: "stop25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffcd1c",
    stopOpacity: 1,
    id: "stop27"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 268.78,
    y1: 67.889999,
    x2: 303.04999,
    y2: 10.38,
    id: "linearGradient3188"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e30613",
    stopOpacity: 1,
    id: "stop3190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f39325",
    stopOpacity: 1,
    id: "stop3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffcd1c",
    stopOpacity: 1,
    id: "stop3194"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 69.779999,
    x2: 265.53,
    y1: 21.530001,
    x1: 232.75,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3267",
    xlinkHref: "#gradient1"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 69.779999,
    x2: 265.53,
    y1: 21.530001,
    x1: 232.75,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3269",
    xlinkHref: "#gradient1"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: -9.1800003,
    x2: 269.81,
    y1: 49.290001,
    x1: 234.96001,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3271",
    xlinkHref: "#gradient2"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: -9.1800003,
    x2: 269.81,
    y1: 49.290001,
    x1: 234.96001,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3273",
    xlinkHref: "#gradient2"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 10.38,
    x2: 303.04999,
    y1: 67.889999,
    x1: 268.78,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3275",
    xlinkHref: "#gradient3"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 10.38,
    x2: 303.04999,
    y1: 67.889999,
    x1: 268.78,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3277",
    xlinkHref: "#gradient3"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient3",
    id: "linearGradient26629",
    gradientUnits: "userSpaceOnUse",
    x1: 268.78,
    y1: 67.889999,
    x2: 303.04999,
    y2: 10.38
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient3",
    id: "linearGradient26631",
    gradientUnits: "userSpaceOnUse",
    x1: 268.78,
    y1: 67.889999,
    x2: 303.04999,
    y2: 10.38
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient2",
    id: "linearGradient26633",
    gradientUnits: "userSpaceOnUse",
    x1: 234.96001,
    y1: 49.290001,
    x2: 269.81,
    y2: -9.1800003
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient2",
    id: "linearGradient26635",
    gradientUnits: "userSpaceOnUse",
    x1: 234.96001,
    y1: 49.290001,
    x2: 269.81,
    y2: -9.1800003
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient1",
    id: "linearGradient26637",
    gradientUnits: "userSpaceOnUse",
    x1: 232.75,
    y1: 21.530001,
    x2: 265.53,
    y2: 69.779999
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient1",
    id: "linearGradient26639",
    gradientUnits: "userSpaceOnUse",
    x1: 232.75,
    y1: 21.530001,
    x2: 265.53,
    y2: 69.779999
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 232.75,
    y1: 21.530001,
    x2: 265.53,
    y2: 69.779999,
    id: "gradient1-7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#bccf21",
    stopOpacity: 1,
    id: "stop9-1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#76b82a",
    stopOpacity: 1,
    id: "stop11-6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#02622c",
    stopOpacity: 1,
    id: "stop13-6"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 232.75,
    y1: 21.530001,
    x2: 265.53,
    y2: 69.779999,
    id: "linearGradient3293"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#bccf21",
    stopOpacity: 1,
    id: "stop3295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#76b82a",
    stopOpacity: 1,
    id: "stop3297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#02622c",
    stopOpacity: 1,
    id: "stop3299"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 234.96001,
    y1: 49.290001,
    x2: 269.81,
    y2: -9.1800003,
    id: "gradient2-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#27348b",
    stopOpacity: 1,
    id: "stop16-8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0053a1",
    stopOpacity: 1,
    id: "stop18-6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0bbbef",
    stopOpacity: 1,
    id: "stop20-2"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 234.96001,
    y1: 49.290001,
    x2: 269.81,
    y2: -9.1800003,
    id: "linearGradient3305"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#27348b",
    stopOpacity: 1,
    id: "stop3307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0053a1",
    stopOpacity: 1,
    id: "stop3309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0bbbef",
    stopOpacity: 1,
    id: "stop3311"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 268.78,
    y1: 67.889999,
    x2: 303.04999,
    y2: 10.38,
    id: "gradient3-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e30613",
    stopOpacity: 1,
    id: "stop23-5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f39325",
    stopOpacity: 1,
    id: "stop25-1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffcd1c",
    stopOpacity: 1,
    id: "stop27-3"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 268.78,
    y1: 67.889999,
    x2: 303.04999,
    y2: 10.38,
    id: "linearGradient3317"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e30613",
    stopOpacity: 1,
    id: "stop3319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f39325",
    stopOpacity: 1,
    id: "stop3321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffcd1c",
    stopOpacity: 1,
    id: "stop3323"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 69.779999,
    x2: 265.53,
    y1: 21.530001,
    x1: 232.75,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3396",
    xlinkHref: "#gradient1-7"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 69.779999,
    x2: 265.53,
    y1: 21.530001,
    x1: 232.75,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3398",
    xlinkHref: "#gradient1-7"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: -9.1800003,
    x2: 269.81,
    y1: 49.290001,
    x1: 234.96001,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3400",
    xlinkHref: "#gradient2-4"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: -9.1800003,
    x2: 269.81,
    y1: 49.290001,
    x1: 234.96001,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3402",
    xlinkHref: "#gradient2-4"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 10.38,
    x2: 303.04999,
    y1: 67.889999,
    x1: 268.78,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3404",
    xlinkHref: "#gradient3-2"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    y2: 10.38,
    x2: 303.04999,
    y1: 67.889999,
    x1: 268.78,
    gradientUnits: "userSpaceOnUse",
    id: "linearGradient3406",
    xlinkHref: "#gradient3-2"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient2",
    id: "linearGradient26850",
    gradientUnits: "userSpaceOnUse",
    x1: 234.96001,
    y1: 49.290001,
    x2: 269.81,
    y2: -9.1800003,
    gradientTransform: "matrix(1.4862154,0,0,-1.4862154,4581.7776,6082.6055)"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient3",
    id: "linearGradient27363",
    gradientUnits: "userSpaceOnUse",
    x1: 268.78,
    y1: 67.889999,
    x2: 303.04999,
    y2: 10.38,
    gradientTransform: "matrix(1.4862154,0,0,-1.4862154,4581.7776,6082.6055)"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#gradient1",
    id: "linearGradient27368",
    gradientUnits: "userSpaceOnUse",
    x1: 232.75,
    y1: 21.530001,
    x2: 265.53,
    y2: 69.779999,
    gradientTransform: "matrix(1.4862154,0,0,-1.4862154,4581.7776,6082.6055)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g3861",
    transform: "matrix(1.25,0,0,-1.25,-5727.222,7603.2594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g31",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g33",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g35",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g37",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g39",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient27368)",
      fillRule: "nonzero",
      stroke: "none"
    },
    vectorEffect: "none",
    d: "m 4985.4337,6024.4648 c -12.1721,-14.0151 -23.7794,-26.202 -37.0513,-23.1701 -7.6095,2.9724 -21.4907,9.4969 -42.9814,23.3038 24.3888,-14.3271 41.6883,-5.2909 56.2235,9.0659 7.1621,-4.7605 15.2783,-7.9001 23.7795,-9.1996 l 0.03,0",
    id: "path43"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g45",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g47",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g49",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g55",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g57",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g59",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g61",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g63",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g65",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g67",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient26850)",
      fillRule: "nonzero",
      stroke: "none"
    },
    vectorEffect: "none",
    d: "m 5015.158,6076.9579 c -19.7072,4.4586 -34.1829,-24.1362 -53.5037,-43.2935 -14.5352,-14.3568 -31.8348,-23.393 -56.2236,-9.0659 -2.0405,1.2979 -4.1421,2.6703 -6.3015,4.1168 l -0.327,0.223 c 33.2021,-4.533 38.6565,75.1579 116.3558,48.0196 l 0,0",
    id: "path71"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g73",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g75",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g77",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g83",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g85",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g87",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g89",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g91",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g93",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g95",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient27363)",
      fillRule: "nonzero",
      stroke: "none"
    },
    vectorEffect: "none",
    d: "m 5064.5598,6046.7728 c -33.1426,4.4587 -40.7372,-76.0645 -115.5978,-45.7011 l -0.5796,0.223 c 13.3759,-2.9725 24.8792,9.155 37.0513,23.1701 20.5246,23.6159 42.9368,52.389 79.1261,22.308 l 0,0",
    id: "path99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g101",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g103",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g105",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g111",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g113",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g115",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g117",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g119",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g121",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g123",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g125",
    transform: "matrix(1.4862154,0,0,-1.4862154,4581.7776,6082.6055)",
    style: {
      fill: "#27348b",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path127",
    d: "M 26.64,60.06 C 21.4425,60.0956 16.2648,60.7026 11.2,61.87 L 9.57,71.31 0,126.52 c 1.67,0.12 7,0.45 14,0.45 18.18,0.29 29.48,-6.59 30.91,-18.89 1.0563,-7.024 -2.9351,-13.8315 -9.58,-16.34 l -1.79,-0.59 1.85,-0.37 c 0.48,-0.1 11.76,-2.5 11.29,-15 C 46.15,62.54 33.9,60.25 26.64,60.06 l 0,0 m 6.74,45.37 c -0.159,3.243 -1.7672,6.243 -4.38,8.17 -3.15,2.4 -7.65,3.4 -11.65,3.4 -1.6482,-0.084 -3.2906,-0.258 -4.92,-0.52 L 15.8,96.8 c 0.43,-0.06 10.91,-1.51 15.46,2.73 1.5971,1.523 2.3828,3.709 2.12,5.9 l 0,0 M 33.8,83.31 c -2.46,2.63 -6.76,4 -12.79,4 -1,0 -3.58,-0.13 -3.58,-0.13 l 2.83,-16.71 c 2.0883,-0.2783 4.1933,-0.412 6.3,-0.4 4.31,0.18 8.89,2.11 9.4,6 0.3938,2.6146 -0.398,5.2686 -2.16,7.24 l 0,0 m 198.78,-4.69 c -6.08,-1.45 -10.06,2.08 -12.7,4.41 l -0.34,0.3 c -0.79,0.7 -1.38,0.92 -1.82,0.7 -0.44,-0.22 -0.76,-1.3 -0.6,-3 l 0.39,-2.3 c -3.924,0.3121 -7.816,0.9374 -11.64,1.87 l -7.94,46.32 11.31,0 3.84,-22.38 c 1.25,-6.7 3.45,-11.53 6.54,-14.36 1.898,-1.9019 4.544,-2.8619 7.22,-2.62 0.892,0.0672 1.714,0.5107 2.26,1.22 1.57,2.1 0.83,6.47 0.23,10 -0.08,0.47 -0.16,0.93 -0.23,1.37 -0.71,4.45 -4.29,24.73 -4.66,26.79 l 11.33,0 4.53,-26.34 c 1.32,-7.73 3.31,-19.33 -7.72,-21.98 l 0,0 M 91.27,126.89 99.54,78.7 c -3.8116,0.3121 -7.591,0.9376 -11.3,1.87 l -7.95,46.32 10.98,0 M 97.18,58.4 c -0.2815,-0.0401 -0.5656,-0.0602 -0.85,-0.06 -1.5665,0.0089 -3.0792,0.5722 -4.27,1.59 -3.0806,2.6485 -3.687,7.1854 -1.41,10.55 1.0399,1.5524 2.6967,2.5832 4.5488,2.8301 1.8522,0.2468 3.7211,-0.3142 5.1312,-1.5401 1.502,-1.2649 2.47,-3.0511 2.71,-5 0.55,-4.12 -2.04,-7.87 -5.86,-8.37 l 0,0 m 346.34,19.34 c -3,-0.1 -8.63,-0.29 -13.28,5.36 -0.68,0.82 -1.16,1.12 -1.53,1 -0.18,-0.08 -0.73,-0.32 -0.35,-3.26 l 0.36,-2.1 c -3.713,0.3145 -7.392,0.94 -11,1.87 l -7.95,46.32 10.63,0 3.26,-19 c 1.33,-7.59 4.14,-12.77 8.36,-15.39 2.763,-1.6831 6.07,-2.2347 9.23,-1.54 l 2.27,-13.21 0,-0.05 m -31.71,0 c -3,-0.1 -8.63,-0.29 -13.28,5.36 -0.67,0.82 -1.15,1.12 -1.53,1 -0.18,-0.08 -0.73,-0.32 -0.35,-3.26 l 0.36,-2.1 c -3.713,0.3145 -7.392,0.94 -11,1.87 l -7.95,46.32 10.63,0 3.26,-19 c 1.33,-7.59 4.14,-12.77 8.36,-15.39 2.763,-1.6831 6.07,-2.2347 9.23,-1.54 l 2.27,-13.21 0,-0.05 m -254.74,8.94 -11.25,0 0,0.12 c -1,6 -4.43,25.72 -4.8,28 -0.158,0.555 0.013,1.152 0.44,1.54 1.13,0.92 3.93,0.06 4.77,-0.23 l -2.06,10.67 c -6.28,1.5 -10.41,1.26 -12.61,-0.76 -2.78,-2.54 -2,-7.66 -1.33,-12.18 0.44,-2.91 2.72,-16.3 4.56,-27 l 0,-0.17 -13.33,0 0,0.12 c -1,6 -4.42,25.72 -4.8,28 -0.158,0.555 0.013,1.152 0.44,1.54 1.13,0.92 3.93,0.06 4.77,-0.23 l -2.06,10.67 c -6.28,1.5 -10.41,1.26 -12.61,-0.76 -2.78,-2.54 -2,-7.66 -1.33,-12.18 0.44,-2.91 2.72,-16.3 4.56,-27 l 0,-0.17 -5.76,0 1.25,-8.06 5.9,0 0,-0.11 c 1,-5.84 1.76,-10.22 1.87,-10.88 3.722,-0.9274 7.515,-1.5396 11.34,-1.83 l -2.21,12.82 13.33,0 0,-0.11 c 1,-5.84 1.76,-10.22 1.88,-10.88 3.722,-0.9274 7.515,-1.5396 11.34,-1.83 l -2.21,12.82 13.68,0 -3.76,8.06 -0.01,0.02 m -75,-8.94 c -3,-0.1 -8.49,-0.29 -13.14,5.36 -0.67,0.82 -1.15,1.12 -1.53,1 -0.18,-0.08 -0.73,-0.32 -0.35,-3.26 l 0.36,-2.1 c -3.7125,0.3145 -7.3921,0.94 -11,1.87 l -8,46.32 10.72,0 3.26,-19 c 1.33,-7.59 4.14,-12.77 8.36,-15.39 2.7525,-1.6727 6.0425,-2.224 9.19,-1.54 L 82.21,77.79 82.07,77.74 M 452.71,126.89 461,78.7 c -3.924,0.3076 -7.817,0.933 -11.64,1.87 l -8,46.32 11.35,0 m 5.58,-68.49 c -0.282,-0.0395 -0.566,-0.0596 -0.85,-0.06 -1.569,0.0091 -3.085,0.5723 -4.28,1.59 -1.498,1.2681 -2.465,3.0526 -2.71,5 -0.55,4.11 2.08,7.86 5.85,8.37 1.851,0.2322 3.713,-0.3269 5.13,-1.54 3.081,-2.6485 3.687,-7.1854 1.41,-10.55 -1.053,-1.5358 -2.705,-2.5561 -4.55,-2.81 l 0,0 M 321.46,75.3 c 0.347,-2.0477 2.123,-3.5448 4.2,-3.54 l 22.11,0 2,-11.44 -37.09,0 -11.44,66.57 11.33,0 4.92,-28.56 15.65,0 1.73,-10.33 -15.59,0 2.18,-12.7 m 191.36,7.12 c -3.344,2.8449 -5.189,7.0735 -5,11.46 0,6.08 5,9.28 9.86,11.62 4.86,2.34 7.36,4.2 6.86,7.68 -0.61,4.22 -5.87,4.68 -8.1,4.68 -3.06,0 -6.94,-1.22 -11.21,-3.53 l -1.81,10.31 c 3.619,1.988 7.654,3.098 11.78,3.24 l 0.35,0 c 12.45,0 19.54,-5.39 20,-15.22 0.28,-6.21 -5.16,-11.36 -10.33,-14.11 -3.64,-2 -5.41,-3.86 -5.41,-5.81 0,-2.7 2.47,-4.58 6,-4.58 3.82,0 9,2.09 10.79,2.93 l 1.68,-9.74 c -2,-0.87 -7.74,-3 -12,-3 -5.59,0.03 -10.23,1.42 -13.46,4.07 l 0,0 M 256.7,78.87 c -3.609,0.2553 -7.189,0.8241 -10.7,1.7 l 6.55,40.63 c -3.83,5.64 -8.08,9.7 -12.87,12.24 l -2,11.74 c 1.86,-0.39 16.63,-4.2 28.78,-28.15 l 7.82,-15.42 11.61,-22.9 c -4.135,0.3791 -8.236,1.0643 -12.27,2.05 -2.49,5 -12.58,25.46 -12.58,25.46 L 256.7,78.87 m -88.19,37.66 c -3.38,-2 -4.58,-6.66 -3.29,-12.87 0.812,-4.4434 2.715,-8.6152 5.54,-12.14 4.88,-5.82 13.4,-6.62 26.05,-2.46 -1.197,-3.8564 -4.065,-6.9701 -7.81,-8.48 -2.822,-1.1933 -5.856,-1.8022 -8.92,-1.79 -6.666,-0.0319 -12.971,3.0212 -17.08,8.27 -2.287,2.9008 -4.047,6.1806 -5.2,9.69 -3.54,10.59 -3,20.47 1.35,26.43 1.934,2.754 5.038,4.454 8.4,4.6 6.15,0.3 11,-3.6 13.87,-7.41 l 0.35,-0.45 -1.17,7 10.92,0 5.71,-35.46 c -3.906,0.3124 -7.779,0.9479 -11.58,1.9 -0.31,4.6 -2.11,17.06 -6.76,21.11 -3.45,2.98 -7.43,3.78 -10.38,2.06 l 0,0 m 180.04,-13.3 c 0.1,-6.88 3.24,-14.79 9.9,-15.88 6,-1 9.95,1.43 10.7,4.3 0.057,0.194 0.104,0.391 0.14,0.59 0.862,4.1172 -1.611,8.199 -5.66,9.34 -2.148,0.505 -4.376,0.569 -6.55,0.19 -1.999,-0.242 -3.926,-0.896 -5.66,-1.92 0.003,1.703 0.731,3.325 2,4.46 2.58,2.35 6.44,3.12 8.51,3.37 3.966,0.521 7.967,-0.672 11,-3.28 2.643,-2.562 4.354,-5.934 4.86,-9.58 0.789,-3.8439 -0.241,-7.8367 -2.79,-10.82 -3.06,-3.56 -8.18,-5.66 -13.77,-5.66 l -0.39,0 c -4.613,0.0521 -9.091,1.5567 -12.8,4.3 -4.68,3.6 -7.58,9.18 -8.64,16.6 -1.27,9 0.42,16.8 4.77,22 3.219,3.888 7.955,6.205 13,6.36 9,0.33 14.49,-2.62 15.1,-3 l 1.75,-10.23 c -4.449,2.716 -9.665,3.9 -14.85,3.37 -7.27,-0.64 -10.75,-5.41 -10.62,-14.51 l 0,0 m 136.87,-24.88 -0.42,0 c -4.613,0.0521 -9.091,1.5567 -12.8,4.3 -4.68,3.6 -7.58,9.18 -8.64,16.6 -1.27,9 0.42,16.8 4.77,22 3.221,3.886 7.955,6.202 13,6.36 9,0.33 14.49,-2.62 15.1,-3 l 1.75,-10.23 c -4.449,2.716 -9.665,3.9 -14.85,3.37 -7.31,-0.69 -10.79,-5.46 -10.66,-14.56 0.1,-6.88 3.24,-14.79 9.9,-15.88 6,-1 10,1.43 10.7,4.3 0.057,0.194 0.104,0.391 0.14,0.59 0.863,4.1143 -1.605,8.195 -5.65,9.34 -2.152,0.504 -4.383,0.569 -6.56,0.19 -1.999,-0.242 -3.926,-0.896 -5.66,-1.92 0.003,1.703 0.731,3.325 2,4.46 2.58,2.35 6.44,3.12 8.51,3.37 3.95,0.507 7.929,-0.685 10.95,-3.28 2.643,-2.564 4.356,-5.9343 4.87,-9.58 0.797,-3.8156 -0.194,-7.7862 -2.69,-10.78 -3.06,-3.55 -8.18,-5.65 -13.76,-5.65 l 0,0",
    vectorEffect: "none",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g129",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g131",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g133",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g135",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g137",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g139",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g141",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g143",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g145",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g147",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g149",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g151",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g153",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g155",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g157",
    transform: "matrix(1.783624,0,0,-1.783624,4581.7776,6125.7833)",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g159",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g161",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g163",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g165",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g167",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g169",
    strokeMiterlimit: 2,
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    },
    transform: "matrix(0.8,0,0,-0.8,4581.7776,6316.3097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27360",
    d: "m 5015.158,6076.9579 c -19.7072,4.4586 -34.1829,-24.1362 -53.5037,-43.2935 -14.5352,-14.3568 -31.8348,-23.393 -56.2236,-9.0659 -2.0405,1.2979 -4.1421,2.6703 -6.3015,4.1168 l -0.327,0.223 c 33.2021,-4.533 38.6565,75.1579 116.3558,48.0196 l 0,0",
    vectorEffect: "none",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero",
      stroke: "none",
      opacity: 0.3,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27365",
    d: "m 5064.5598,6046.7728 c -33.1426,4.4587 -40.7372,-76.0645 -115.5978,-45.7011 l -0.5796,0.223 c 13.3759,-2.9725 24.8792,9.155 37.0513,23.1701 20.5246,23.6159 42.9368,52.389 79.1261,22.308 l 0,0",
    vectorEffect: "none",
    style: {
      fill: "#1a1a1a",
      fillRule: "nonzero",
      stroke: "none",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27370",
    d: "m 4985.4337,6024.4648 c -12.1721,-14.0151 -23.7794,-26.202 -37.0513,-23.1701 -7.6095,2.9724 -21.4907,9.4969 -42.9814,23.3038 24.3888,-14.3271 41.6883,-5.2909 56.2235,9.0659 7.1621,-4.7605 15.2783,-7.9001 23.7795,-9.1996 l 0.03,0",
    vectorEffect: "none",
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "none",
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrittanyFerries);
export default __webpack_public_path__ + "static/media/Brittany_Ferries.8feb2d781b11049a5885e75d33025783.svg";
export { ForwardRef as ReactComponent };